import { memberKey, type AudienceSelection } from './announcementAudience';

/**
 * Downloads the saved image or GIF each of these members' group shows, once
 * per URL, and hands it back as a File per member - so a platform added to a
 * group gets the picture the card already shows, without the admin picking
 * the same file again.
 *
 * Fetched as-is: a GIF stays animated, and an image was compressed when it
 * was first uploaded. Throws with the pairs it could not cover, so the form
 * can ask for the file by hand instead (the storage CDN must allow CORS from
 * the admin origin, which dev's does).
 */
export const copyStoredMedia = async (
  members: AudienceSelection
): Promise<Map<string, File>> => {
  const downloads = new Map<string, Promise<File>>();
  const files = new Map<string, File>();

  const download = (url: string) => {
    if (!downloads.has(url))
      downloads.set(
        url,
        fetch(url, { cache: 'no-store' }).then(async (response) => {
          if (!response.ok) throw new Error(String(response.status));
          const blob = await response.blob();
          const name = decodeURIComponent(
            new URL(url).pathname.split('/').pop() || 'media'
          );
          return new File([blob], name, { type: blob.type });
        })
      );
    return downloads.get(url) as Promise<File>;
  };

  await Promise.all(
    members.map(async (member) => {
      files.set(
        memberKey(member),
        await download(member.group.media as string)
      );
    })
  );

  return files;
};
